import base64ToBlob from 'b64-to-blob';
export function dataUriToBlob(base64DataUri) {
  const base64String = base64DataUri.split(',')[1];
  return base64ToBlob(base64String);
}